module.exports = __webpack_public_path__ + "static/img/21-0115-cover.233f5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/21-0115-cover.jpg
// module id = mgoI
// module chunks = 0